import { POSTSupportWholesalerBody } from '@cbgms/api'
import { UseMutationOptions, useMutation } from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { createWholesaler } from '../state/actions'

interface InputProps {
  wholesaler: POSTSupportWholesalerBody
}

export const useMutateCreateWholesaler = (options?: UseMutationOptions<{ UUID: string }, unknown, InputProps, unknown> | undefined) => {
  const dispatch = useDispatch()

  return useMutation(async ({ wholesaler }) => {
    const { Data } = await dispatch(createWholesaler(wholesaler))
    return Data
  }, options)
}
